import {
  Request,
} from '@/utils';

export const fetchVerificationCode = (params = {}, headers = {}) => (
  Request.post(
    '/usercenter/smsverifycode/send/v1',
    {
      ...params,
    },
    {
      headers,
    },
  )
);

export const loginApp = (params = {}, headers = {}) => (
  Request.post(
    '/usercenter/mobile/login/v1',
    {
      ...params,
    },
    {
      headers,
    },
  )
);

export const fetchTickets = (params = {}, headers = {}) => (
  Request.form(
    '/promotion/coupon/send_coupon/v1',
    {
      ...params,
    },
    {
      headers,
    },
  )
);

export const saveFormData = (params = {}, headers = {}) => (
  Request.post(
    '/crm/api/thirdparty/code/add/v1',
    {
      ...params,
    },
    {
      headers,
    },
  )
);



// WEBPACK FOOTER //
// ./src/pages/Application/api/index.js